// Mirror of ADMIN_EMAILS in backend/app/dependencies.py. Keep in sync.
// Used to gate admin-only UI controls (roster banner, agenda write actions, …).

import { isEntraConfigured } from './msalConfig';

export const ADMIN_EMAILS: ReadonlySet<string> = new Set([
  'brad@ember-infra.com',
  'intern@ember-infra.com',
]);

export function isAdmin(email: string | null | undefined): boolean {
  // Local dev: Entra is not configured, API is hit via X-Api-Key which the
  // backend grants full access to. Treat the local user as admin so the UI
  // exposes write controls; the backend is the authoritative check in prod.
  if (!isEntraConfigured) return true;
  if (!email) return false;
  return ADMIN_EMAILS.has(email.toLowerCase());
}
